










import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import {
  AcoFormData,
  ACTION_TYPE,
  AdgroupFormData,
  CampaignFormData,
  genDestinationUrlTypes,
  FullNormalFormData,
  NormalCreative
} from '@tt4b/ttam-enums';
import DestinationType from './index';
import { useCreativeFormStatus } from '@tt4b/ttam-hooks';

const name = 'ttam-destination-type-compose';
export default defineComponent({
  name,
  components: {
    TtamDestinationTypeOptions: DestinationType.TtamDestinationTypeOptions,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    actionType: {
      type: String as PropType<keyof typeof ACTION_TYPE>,
      default: ACTION_TYPE.CREATE,
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, creativeData, actionType, normalCreativeData } = toRefs(props);
    const { options } = DestinationType.usePropsOptions({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      creativeFormData: creativeData,
      normalCreativeData,
    });
    const { isShowDestinationUrlTypeSelector: visible } = useCreativeFormStatus({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      creativeFormData: creativeData,
      normalCreativeData,
      createMode: actionType,
    });
    const _desinationUrlType = computed({
      get() {
        return creativeData.value.destinationUrlType ?? genDestinationUrlTypes().WEB_SITE.name;
      },
      set(val) {
        emit('change-destination-type', val);
      },
    });

    return {
      name,
      _desinationUrlType,
      options,
      visible,
    };
  },
});
